export const VALUABLES_TO_BE_PLACE_OPTIONS = [
    { label: 'On Body', value: 'On Body' },
    { label: 'In Coffin', value: 'In Coffin' },
    { label: 'On Coffin', value: 'On Coffin' },
    { label: 'In Memoriam Book', value: 'In Memoriam Book' },
    { label: 'On Display in Chapel', value: 'On Display in Chapel' },
    { label: 'In Hands', value: 'In Hands' }
];

export const VALUABLES_LOCATION_OPTIONS = [
    { label: 'Awaiting Delivery', value: 'Awaiting Delivery' },
    { label: 'Held In Storage', value: 'Received' },
    { label: 'Placed', value: 'Placed' },
    { label: 'Returned', value: 'Returned' }
];

export const VALUABLES_LOCATION_QUESTIONS = [
    { value: 'Returned', label: 'Who was it returned to?' },
    { value: 'Placed', label: 'Where was it placed with the deceased?' },
    { value: 'Received', label: 'Where are we storing it until required?' },
    { value: 'Awaiting Delivery', label: 'Where & when will it be delivered?' }
];

export const VALUABLES_RETURN_OPTIONS = [
    { label: 'Remain with deceased', value: 'Remain' },
    { label: 'To be returned', value: 'Return' },
    { label: 'Unsure', value: '' }
];
